import "./footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <h3>Paschimanchal</h3>
      <p>Connecting Youth, Building Future</p>

      <div className="socials">
        <a href="#">Instagram</a>
        <a href="#">YouTube</a>
        <a href="#">Twitter</a>
      </div>

      <p>© 2026 All Rights Reserved</p>
    </footer>
  );
}